// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file internalapi/v1/contract_model.proto (package internalapi.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { AreaCode } from "../../types/v1/area_pb";
import { file_types_v1_area } from "../../types/v1/area_pb";
import type { DatePeriod } from "../../types/v1/date_pb";
import { file_types_v1_date } from "../../types/v1/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file internalapi/v1/contract_model.proto.
 */
export const file_internalapi_v1_contract_model: GenFile = /*@__PURE__*/
  fileDesc("CiNpbnRlcm5hbGFwaS92MS9jb250cmFjdF9tb2RlbC5wcm90bxIOaW50ZXJuYWxhcGkudjEiZAoQSW52b2ljZVJlY2lwaWVudBIZCgVlbWFpbBgBIAEoCUIKukgHyAEBcgJgARIVCgVwaG9uZRgCIAEoCUIGukgDyAEBEh4KDmJpbGxpbmdfcGVyc29uGAMgASgJQga6SAPIAQEi2QMKEEVjbGVhckZlZVBhdHRlcm4SUAoRcGh5c2ljYWxfcGh5c2ljYWwYASADKAsyKC5pbnRlcm5hbGFwaS52MS5FY2xlYXJGZWVQYXR0ZXJuLlBhdHRlcm5CC7pICMgBAZIBAggBEk8KEHBoeXNpY2FsX2Z1dHVyZXMYAiADKAsyKC5pbnRlcm5hbGFwaS52MS5FY2xlYXJGZWVQYXR0ZXJuLlBhdHRlcm5CC7pICMgBAZIBAggBEj8KDXNwZWNpYWxfdHJhZGUYAyADKAsyKC5pbnRlcm5hbGFwaS52MS5FY2xlYXJGZWVQYXR0ZXJuLlBhdHRlcm4a4AEKB1BhdHRlcm4SLAoJZnJvbV9kYXRlGAEgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZUIGukgDyAEBEioKB3RvX2RhdGUYAiABKAsyES5nb29nbGUudHlwZS5EYXRlQga6SAPIAQESIAoIZnJvbV9rd2gYAyABKARCDrpICzIJGP////////8PEiMKBnRvX2t3aBgEIAEoBEIOukgLMgkY/////////w9IAIgBARIpCgNmZWUYBSABKAsyFC5nb29nbGUudHlwZS5EZWNpbWFsQga6SAPIAQFCCQoHX3RvX2t3aCL/CAoLQmFua0FjY291bnQSrAIKCWJhbmtfbmFtZRgBIAEoCUKYArpIlALIAQFyjgIyiwJeW+OCouOCpOOCpuOCqOOCquOCq+OCreOCr+OCseOCs+OCteOCt+OCueOCu+OCveOCv+ODgeODhOODhuODiOODiuODi+ODjOODjeODjuODj+ODkuODleODmOODm+ODnuODn+ODoOODoeODouODpOODpuODqOODqeODquODq+ODrOODreODr+ODsuODs+OCrOOCruOCsOOCsuOCtOOCtuOCuOOCuuOCvOOCvuODgOODguODheODh+ODieODkOODk+ODluODmeODnOODkeODlOODl+ODmuODneODtO+9gS3vvZrvvKEt77y677yQLe+8me+8iO+8ie+8ju+8je+8j+OAjOOAjSDjgIBdKyQSrgIKC2JyYW5jaF9uYW1lGAIgASgJQpgCukiUAsgBAXKOAjKLAl5b44Ki44Kk44Km44Ko44Kq44Kr44Kt44Kv44Kx44Kz44K144K344K544K744K944K/44OB44OE44OG44OI44OK44OL44OM44ON44OO44OP44OS44OV44OY44Ob44Oe44Of44Og44Oh44Oi44Ok44Om44Oo44Op44Oq44Or44Os44Ot44Ov44Oy44Oz44Ks44Ku44Kw44Ky44K044K244K444K644K844K+44OA44OC44OF44OH44OJ44OQ44OT44OW44OZ44Oc44OR44OU44OX44Oa44Od44O0772BLe+9mu+8oS3vvLrvvJAt77yZ77yI77yJ77yO77yN77yP44CM44CNIOOAgF0rJBJMCgxhY2NvdW50X3R5cGUYAyABKA4yJy5pbnRlcm5hbGFwaS52MS5CYW5rQWNjb3VudC5BY2NvdW50VHlwZUINukgKyAEBggEEEAEgABIuCg5hY2NvdW50X251bWJlchgEIAEoCUIWukgTyAEBcg4yDF4oWzAtOV17N30pJBKxAgoOYWNjb3VudF9ob2xkZXIYBSABKAlCmAK6SJQCyAEBco4CMosCXlvjgqLjgqTjgqbjgqjjgqrjgqvjgq3jgq/jgrHjgrPjgrXjgrfjgrnjgrvjgr3jgr/jg4Hjg4Tjg4bjg4jjg4rjg4vjg4zjg43jg47jg4/jg5Ljg5Xjg5jjg5vjg57jg5/jg6Djg6Hjg6Ljg6Tjg6bjg6jjg6njg6rjg6vjg6zjg63jg6/jg7Ljg7Pjgqzjgq7jgrDjgrLjgrTjgrbjgrjjgrrjgrzjgr7jg4Djg4Ljg4Xjg4fjg4njg5Djg5Pjg5bjg5njg5zjg5Hjg5Tjg5fjg5rjg53jg7TvvYEt772a77yhLe+8uu+8kC3vvJnvvIjvvInvvI7vvI3vvI/jgIzjgI0g44CAXSskIl4KC0FjY291bnRUeXBlEhwKGEFDQ09VTlRfVFlQRV9VTlNQRUNJRklFRBAAEhcKE0FDQ09VTlRfVFlQRV9TQVZJTkcQARIYChRBQ0NPVU5UX1RZUEVfQ1VSUkVOVBACIv0EChtSZWNlaXZpbmdQYXltZW50QmFua0FjY291bnQSrAIKCWJhbmtfbmFtZRgBIAEoCUKYArpIlALIAQFyjgIyiwJeW+OCouOCpOOCpuOCqOOCquOCq+OCreOCr+OCseOCs+OCteOCt+OCueOCu+OCveOCv+ODgeODhOODhuODiOODiuODi+ODjOODjeODjuODj+ODkuODleODmOODm+ODnuODn+ODoOODoeODouODpOODpuODqOODqeODquODq+ODrOODreODr+ODsuODs+OCrOOCruOCsOOCsuOCtOOCtuOCuOOCuuOCvOOCvuODgOODguODheODh+ODieODkOODk+ODluODmeODnOODkeODlOODl+ODmuODneODtO+9gS3vvZrvvKEt77y677yQLe+8me+8iO+8ie+8ju+8je+8j+OAjOOAjSDjgIBdKyQSrgIKC2JyYW5jaF9uYW1lGAIgASgJQpgCukiUAsgBAXKOAjKLAl5b44Ki44Kk44Km44Ko44Kq44Kr44Kt44Kv44Kx44Kz44K144K344K544K744K944K/44OB44OE44OG44OI44OK44OL44OM44ON44OO44OP44OS44OV44OY44Ob44Oe44Of44Og44Oh44Oi44Ok44Om44Oo44Op44Oq44Or44Os44Ot44Ov44Oy44Oz44Ks44Ku44Kw44Ky44K044K244K444K644K844K+44OA44OC44OF44OH44OJ44OQ44OT44OW44OZ44Oc44OR44OU44OX44Oa44Od44O0772BLe+9mu+8oS3vvLrvvJAt77yZ77yI77yJ77yO77yN77yP44CM44CNIOOAgF0rJCK+CQoST3JnYW5pemF0aW9uT3B0aW9uEkcKB29wdGlvbnMYASADKAsyKS5pbnRlcm5hbGFwaS52MS5Pcmdhbml6YXRpb25PcHRpb24uT3B0aW9uQgu6SAjIAQGSAQIIARIxChNtYXJnaW5fY2FsbF9wZXJpb2RzGAIgAygLMhQudHlwZXMudjEuRGF0ZVBlcmlvZBIyChVtYXJnaW5fY2FsbF90aHJlc2hvbGQYAyABKARCDrpICzIJGP////////8PSACIAQESMAoSc2V0dGxlbWVudF9wZXJpb2RzGAQgAygLMhQudHlwZXMudjEuRGF0ZVBlcmlvZBIlCh1zaG91bGRfcmVjb25jaWxlX2Zyb21fZGVwb3NpdBgFIAEoCBI+ChRtYXJnaW5fY2FsbF9pbnZvaWNlcxgGIAMoCzIgLmludGVybmFsYXBpLnYxLkludm9pY2VSZWNpcGllbnQSJgoeaXNfY2xlYXJlcl9yZW1pdHRhbmNlX2N1c3RvbWVyGAcgASgIEi0KB2NsZWFyZXIYCCABKA4yFy5pbnRlcm5hbGFwaS52MS5DbGVhcmVySAGIAQESIAoYaXNfYmlsYXRlcmFsX3ZtX2V4Y2hhbmdlGAkgASgIEiAKA210YRgKIAEoBEIOukgLMgkY/////////w9IAogBARInCgplY2xlYXJfbXRhGAsgASgEQg66SAsyCRj/////////D0gDiAEBElgKF2ludGVyZXN0X3RhcmdldF9wZXJpb2RzGA0gAygLMjcuaW50ZXJuYWxhcGkudjEuT3JnYW5pemF0aW9uT3B0aW9uLkludGVyZXN0VGFyZ2V0UGVyaW9kGvcCCgZPcHRpb24SLAoJZnJvbV9kYXRlGAEgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZUIGukgDyAEBEioKB3RvX2RhdGUYAiABKAsyES5nb29nbGUudHlwZS5EYXRlQga6SAPIAQESOwoGb3B0aW9uGAMgASgOMhwuaW50ZXJuYWxhcGkudjEuRWNsZWFyT3B0aW9uQg26SArIAQGCAQQQASAAElMKFW1hcmdpbl9jYWxsX2ZyZXF1ZW5jeRgEIAEoDjIjLmludGVybmFsYXBpLnYxLk1hcmdpbkNhbGxGcmVxdWVuY3lCCrpIB4IBBBABIABIAIgBARJPChNtYXJnaW5fY2FsbF93ZWVrZGF5GAUgASgOMiEuaW50ZXJuYWxhcGkudjEuTWFyZ2luQ2FsbFdlZWtkYXlCCrpIB4IBBBABIABIAYgBAUIYChZfbWFyZ2luX2NhbGxfZnJlcXVlbmN5QhYKFF9tYXJnaW5fY2FsbF93ZWVrZGF5GnAKFEludGVyZXN0VGFyZ2V0UGVyaW9kEiwKCWZyb21fZGF0ZRgBIAEoCzIRLmdvb2dsZS50eXBlLkRhdGVCBrpIA8gBARIqCgd0b19kYXRlGAIgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZUIGukgDyAEBQhgKFl9tYXJnaW5fY2FsbF90aHJlc2hvbGRCCgoIX2NsZWFyZXJCBgoEX210YUINCgtfZWNsZWFyX210YUoECAwQDVISaXNfaW50ZXJlc3RfdGFyZ2V0IpABCgtBcmVhTWFwcGluZxJOCiZzZXR0bGVtZW50X2RpZmZlcmVuY2VfdGFyZ2V0X2FyZWFfY29kZRgBIAEoDjISLnR5cGVzLnYxLkFyZWFDb2RlQgq6SAeCAQQQASAAEjEKCWFyZWFfY29kZRgCIAEoDjISLnR5cGVzLnYxLkFyZWFDb2RlQgq6SAeCAQQQASAAIocEChRPcmdhbml6YXRpb25Db250cmFjdBIXCg9vcmdhbml6YXRpb25faWQYASABKAkSVQofcGh5c2ljYWxfY29udHJhY3RfZGVsaXZlcnlfdHlwZRgCIAEoDjIsLmludGVybmFsYXBpLnYxLlBoeXNpY2FsQ29udHJhY3REZWxpdmVyeVR5cGUSLQoPcGF5bWVudF90aW1pbmdzGAMgAygLMhQudHlwZXMudjEuRGF0ZVBlcmlvZBI8ChJlY2xlYXJfZmVlX3BhdHRlcm4YBCABKAsyIC5pbnRlcm5hbGFwaS52MS5FY2xlYXJGZWVQYXR0ZXJuEjkKD3BheW1lbnRfYWNjb3VudBgFIAEoCzIbLmludGVybmFsYXBpLnYxLkJhbmtBY2NvdW50SACIAQESTgoZcmVjZWl2aW5nX3BheW1lbnRfYWNjb3VudBgGIAEoCzIrLmludGVybmFsYXBpLnYxLlJlY2VpdmluZ1BheW1lbnRCYW5rQWNjb3VudBI/ChNvcmdhbml6YXRpb25fb3B0aW9uGAcgASgLMiIuaW50ZXJuYWxhcGkudjEuT3JnYW5pemF0aW9uT3B0aW9uEjIKDWFyZWFfbWFwcGluZ3MYCCADKAsyGy5pbnRlcm5hbGFwaS52MS5BcmVhTWFwcGluZ0ISChBfcGF5bWVudF9hY2NvdW50KqEBChxQaHlzaWNhbENvbnRyYWN0RGVsaXZlcnlUeXBlEi8KK1BIWVNJQ0FMX0NPTlRSQUNUX0RFTElWRVJZX1RZUEVfVU5TUEVDSUZJRUQQABImCiJQSFlTSUNBTF9DT05UUkFDVF9ERUxJVkVSWV9UWVBFX0JHEAESKAokUEhZU0lDQUxfQ09OVFJBQ1RfREVMSVZFUllfVFlQRV9KRVBYEAIqoAEKDEVjbGVhck9wdGlvbhIdChlFQ0xFQVJfT1BUSU9OX1VOU1BFQ0lGSUVEEAASFQoRRUNMRUFSX09QVElPTl8xXzEQARIVChFFQ0xFQVJfT1BUSU9OXzFfMhACEhUKEUVDTEVBUl9PUFRJT05fMV8zEAMSFQoRRUNMRUFSX09QVElPTl8yXzEQBBIVChFFQ0xFQVJfT1BUSU9OXzJfMhAFKqMBChNNYXJnaW5DYWxsRnJlcXVlbmN5EiUKIU1BUkdJTl9DQUxMX0ZSRVFVRU5DWV9VTlNQRUNJRklFRBAAEh8KG01BUkdJTl9DQUxMX0ZSRVFVRU5DWV9EQUlMWRABEiAKHE1BUkdJTl9DQUxMX0ZSRVFVRU5DWV9XRUVLTFkQAhIiCh5NQVJHSU5fQ0FMTF9GUkVRVUVOQ1lfQklXRUVLTFkQAyreAQoRTWFyZ2luQ2FsbFdlZWtkYXkSIwofTUFSR0lOX0NBTExfV0VFS0RBWV9VTlNQRUNJRklFRBAAEh4KGk1BUkdJTl9DQUxMX1dFRUtEQVlfTU9OREFZEAESHwobTUFSR0lOX0NBTExfV0VFS0RBWV9UVUVTREFZEAISIQodTUFSR0lOX0NBTExfV0VFS0RBWV9XRURORVNEQVkQAxIgChxNQVJHSU5fQ0FMTF9XRUVLREFZX1RIVVJTREFZEAQSHgoaTUFSR0lOX0NBTExfV0VFS0RBWV9GUklEQVkQBSpHCgdDbGVhcmVyEhcKE0NMRUFSRVJfVU5TUEVDSUZJRUQQABISCg5DTEVBUkVSX1NUT05FWBABEg8KC0NMRUFSRVJfS0dJEAJC0QEKEmNvbS5pbnRlcm5hbGFwaS52MUISQ29udHJhY3RNb2RlbFByb3RvUAFaTmdpdGh1Yi5jb20vZW5lY2hhaW4vZXBvc2l0aW9uLWFwcC9iYWNrZW5kL2dlbi9wcm90by9pbnRlcm5hbGFwaS92MTtpbnRlcm5hbGFwaaICA0lYWKoCDkludGVybmFsYXBpLlYxygIOSW50ZXJuYWxhcGlcVjHiAhpJbnRlcm5hbGFwaVxWMVxHUEJNZXRhZGF0YeoCD0ludGVybmFsYXBpOjpWMWIGcHJvdG8z", [file_buf_validate_validate, file_google_type_date, file_google_type_decimal, file_types_v1_area, file_types_v1_date]);

/**
 * @generated from message internalapi.v1.InvoiceRecipient
 */
export type InvoiceRecipient = Message<"internalapi.v1.InvoiceRecipient"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string phone = 2;
   */
  phone: string;

  /**
   * @generated from field: string billing_person = 3;
   */
  billingPerson: string;
};

/**
 * Describes the message internalapi.v1.InvoiceRecipient.
 * Use `create(InvoiceRecipientSchema)` to create a new message.
 */
export const InvoiceRecipientSchema: GenMessage<InvoiceRecipient> = /*@__PURE__*/
  messageDesc(file_internalapi_v1_contract_model, 0);

/**
 * @generated from message internalapi.v1.EclearFeePattern
 */
export type EclearFeePattern = Message<"internalapi.v1.EclearFeePattern"> & {
  /**
   * @generated from field: repeated internalapi.v1.EclearFeePattern.Pattern physical_physical = 1;
   */
  physicalPhysical: EclearFeePattern_Pattern[];

  /**
   * @generated from field: repeated internalapi.v1.EclearFeePattern.Pattern physical_futures = 2;
   */
  physicalFutures: EclearFeePattern_Pattern[];

  /**
   * 特種取引手数料パターン。特種取引フラグが付いた組織の約定で、通常の eClear 手数料の代わりに使う（現現のみ）。
   * 登録しない組織が通常なので 0 件を許す。
   *
   * @generated from field: repeated internalapi.v1.EclearFeePattern.Pattern special_trade = 3;
   */
  specialTrade: EclearFeePattern_Pattern[];
};

/**
 * Describes the message internalapi.v1.EclearFeePattern.
 * Use `create(EclearFeePatternSchema)` to create a new message.
 */
export const EclearFeePatternSchema: GenMessage<EclearFeePattern> = /*@__PURE__*/
  messageDesc(file_internalapi_v1_contract_model, 1);

/**
 * @generated from message internalapi.v1.EclearFeePattern.Pattern
 */
export type EclearFeePattern_Pattern = Message<"internalapi.v1.EclearFeePattern.Pattern"> & {
  /**
   * @generated from field: google.type.Date from_date = 1;
   */
  fromDate?: Date;

  /**
   * @generated from field: google.type.Date to_date = 2;
   */
  toDate?: Date;

  /**
   * MAX_SAFE_INTEGER
   *
   * @generated from field: uint64 from_kwh = 3;
   */
  fromKwh: bigint;

  /**
   * MAX_SAFE_INTEGER
   *
   * @generated from field: optional uint64 to_kwh = 4;
   */
  toKwh?: bigint;

  /**
   * @generated from field: google.type.Decimal fee = 5;
   */
  fee?: Decimal;
};

/**
 * Describes the message internalapi.v1.EclearFeePattern.Pattern.
 * Use `create(EclearFeePattern_PatternSchema)` to create a new message.
 */
export const EclearFeePattern_PatternSchema: GenMessage<EclearFeePattern_Pattern> = /*@__PURE__*/
  messageDesc(file_internalapi_v1_contract_model, 1, 0);

/**
 * @generated from message internalapi.v1.BankAccount
 */
export type BankAccount = Message<"internalapi.v1.BankAccount"> & {
  /**
   * @generated from field: string bank_name = 1;
   */
  bankName: string;

  /**
   * @generated from field: string branch_name = 2;
   */
  branchName: string;

  /**
   * @generated from field: internalapi.v1.BankAccount.AccountType account_type = 3;
   */
  accountType: BankAccount_AccountType;

  /**
   * @generated from field: string account_number = 4;
   */
  accountNumber: string;

  /**
   * @generated from field: string account_holder = 5;
   */
  accountHolder: string;
};

/**
 * Describes the message internalapi.v1.BankAccount.
 * Use `create(BankAccountSchema)` to create a new message.
 */
export const BankAccountSchema: GenMessage<BankAccount> = /*@__PURE__*/
  messageDesc(file_internalapi_v1_contract_model, 2);

/**
 * @generated from enum internalapi.v1.BankAccount.AccountType
 */
export enum BankAccount_AccountType {
  /**
   * @generated from enum value: ACCOUNT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 普通
   *
   * @generated from enum value: ACCOUNT_TYPE_SAVING = 1;
   */
  SAVING = 1,

  /**
   * 当座
   *
   * @generated from enum value: ACCOUNT_TYPE_CURRENT = 2;
   */
  CURRENT = 2,
}

/**
 * Describes the enum internalapi.v1.BankAccount.AccountType.
 */
export const BankAccount_AccountTypeSchema: GenEnum<BankAccount_AccountType> = /*@__PURE__*/
  enumDesc(file_internalapi_v1_contract_model, 2, 0);

/**
 * @generated from message internalapi.v1.ReceivingPaymentBankAccount
 */
export type ReceivingPaymentBankAccount = Message<"internalapi.v1.ReceivingPaymentBankAccount"> & {
  /**
   * @generated from field: string bank_name = 1;
   */
  bankName: string;

  /**
   * @generated from field: string branch_name = 2;
   */
  branchName: string;
};

/**
 * Describes the message internalapi.v1.ReceivingPaymentBankAccount.
 * Use `create(ReceivingPaymentBankAccountSchema)` to create a new message.
 */
export const ReceivingPaymentBankAccountSchema: GenMessage<ReceivingPaymentBankAccount> = /*@__PURE__*/
  messageDesc(file_internalapi_v1_contract_model, 3);

/**
 * @generated from message internalapi.v1.OrganizationOption
 */
export type OrganizationOption = Message<"internalapi.v1.OrganizationOption"> & {
  /**
   * @generated from field: repeated internalapi.v1.OrganizationOption.Option options = 1;
   */
  options: OrganizationOption_Option[];

  /**
   * @generated from field: repeated types.v1.DatePeriod margin_call_periods = 2;
   */
  marginCallPeriods: DatePeriod[];

  /**
   * MAX_SAFE_INTEGER
   *
   * @generated from field: optional uint64 margin_call_threshold = 3;
   */
  marginCallThreshold?: bigint;

  /**
   * @generated from field: repeated types.v1.DatePeriod settlement_periods = 4;
   */
  settlementPeriods: DatePeriod[];

  /**
   * @generated from field: bool should_reconcile_from_deposit = 5;
   */
  shouldReconcileFromDeposit: boolean;

  /**
   * @generated from field: repeated internalapi.v1.InvoiceRecipient margin_call_invoices = 6;
   */
  marginCallInvoices: InvoiceRecipient[];

  /**
   * @generated from field: bool is_clearer_remittance_customer = 7;
   */
  isClearerRemittanceCustomer: boolean;

  /**
   * @generated from field: optional internalapi.v1.Clearer clearer = 8;
   */
  clearer?: Clearer;

  /**
   * @generated from field: bool is_bilateral_vm_exchange = 9;
   */
  isBilateralVmExchange: boolean;

  /**
   * MTA(最小引渡金額), MAX_SAFE_INTEGER
   *
   * @generated from field: optional uint64 mta = 10;
   */
  mta?: bigint;

  /**
   * eClearMTA(eClear→顧客), MAX_SAFE_INTEGER
   *
   * @generated from field: optional uint64 eclear_mta = 11;
   */
  eclearMta?: bigint;

  /**
   * 付利対象の期間。期間の間は空いてよく、重なりは許さない。
   * 実行日がどれかの期間に含まれる組織には、クリアラー入出金予定を作成しない
   *
   * @generated from field: repeated internalapi.v1.OrganizationOption.InterestTargetPeriod interest_target_periods = 13;
   */
  interestTargetPeriods: OrganizationOption_InterestTargetPeriod[];
};

/**
 * Describes the message internalapi.v1.OrganizationOption.
 * Use `create(OrganizationOptionSchema)` to create a new message.
 */
export const OrganizationOptionSchema: GenMessage<OrganizationOption> = /*@__PURE__*/
  messageDesc(file_internalapi_v1_contract_model, 4);

/**
 * @generated from message internalapi.v1.OrganizationOption.Option
 */
export type OrganizationOption_Option = Message<"internalapi.v1.OrganizationOption.Option"> & {
  /**
   * @generated from field: google.type.Date from_date = 1;
   */
  fromDate?: Date;

  /**
   * @generated from field: google.type.Date to_date = 2;
   */
  toDate?: Date;

  /**
   * @generated from field: internalapi.v1.EclearOption option = 3;
   */
  option: EclearOption;

  /**
   * @generated from field: optional internalapi.v1.MarginCallFrequency margin_call_frequency = 4;
   */
  marginCallFrequency?: MarginCallFrequency;

  /**
   * @generated from field: optional internalapi.v1.MarginCallWeekday margin_call_weekday = 5;
   */
  marginCallWeekday?: MarginCallWeekday;
};

/**
 * Describes the message internalapi.v1.OrganizationOption.Option.
 * Use `create(OrganizationOption_OptionSchema)` to create a new message.
 */
export const OrganizationOption_OptionSchema: GenMessage<OrganizationOption_Option> = /*@__PURE__*/
  messageDesc(file_internalapi_v1_contract_model, 4, 0);

/**
 * InterestTargetPeriod は付利対象の期間 1 件。終了日を含む。
 *
 * @generated from message internalapi.v1.OrganizationOption.InterestTargetPeriod
 */
export type OrganizationOption_InterestTargetPeriod = Message<"internalapi.v1.OrganizationOption.InterestTargetPeriod"> & {
  /**
   * @generated from field: google.type.Date from_date = 1;
   */
  fromDate?: Date;

  /**
   * @generated from field: google.type.Date to_date = 2;
   */
  toDate?: Date;
};

/**
 * Describes the message internalapi.v1.OrganizationOption.InterestTargetPeriod.
 * Use `create(OrganizationOption_InterestTargetPeriodSchema)` to create a new message.
 */
export const OrganizationOption_InterestTargetPeriodSchema: GenMessage<OrganizationOption_InterestTargetPeriod> = /*@__PURE__*/
  messageDesc(file_internalapi_v1_contract_model, 4, 1);

/**
 * AreaMapping は差額精算対象エリアから受渡エリアへの読み替え1件。
 *
 * 取引はエリア1本で入ってくる。その当事者がそのエリアのBGを持っていない場合に、
 * 入ってきたエリアを settlement_difference_target_area_code として扱ってこの表を引き、
 * 受渡エリアを area_code へ読み替える。
 *
 * @generated from message internalapi.v1.AreaMapping
 */
export type AreaMapping = Message<"internalapi.v1.AreaMapping"> & {
  /**
   * @generated from field: types.v1.AreaCode settlement_difference_target_area_code = 1;
   */
  settlementDifferenceTargetAreaCode: AreaCode;

  /**
   * @generated from field: types.v1.AreaCode area_code = 2;
   */
  areaCode: AreaCode;
};

/**
 * Describes the message internalapi.v1.AreaMapping.
 * Use `create(AreaMappingSchema)` to create a new message.
 */
export const AreaMappingSchema: GenMessage<AreaMapping> = /*@__PURE__*/
  messageDesc(file_internalapi_v1_contract_model, 5);

/**
 * @generated from message internalapi.v1.OrganizationContract
 */
export type OrganizationContract = Message<"internalapi.v1.OrganizationContract"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: internalapi.v1.PhysicalContractDeliveryType physical_contract_delivery_type = 2;
   */
  physicalContractDeliveryType: PhysicalContractDeliveryType;

  /**
   * @generated from field: repeated types.v1.DatePeriod payment_timings = 3;
   */
  paymentTimings: DatePeriod[];

  /**
   * @generated from field: internalapi.v1.EclearFeePattern eclear_fee_pattern = 4;
   */
  eclearFeePattern?: EclearFeePattern;

  /**
   * @generated from field: optional internalapi.v1.BankAccount payment_account = 5;
   */
  paymentAccount?: BankAccount;

  /**
   * @generated from field: internalapi.v1.ReceivingPaymentBankAccount receiving_payment_account = 6;
   */
  receivingPaymentAccount?: ReceivingPaymentBankAccount;

  /**
   * @generated from field: internalapi.v1.OrganizationOption organization_option = 7;
   */
  organizationOption?: OrganizationOption;

  /**
   * 読み替えを持たない組織が通常なので、空で正常。
   *
   * @generated from field: repeated internalapi.v1.AreaMapping area_mappings = 8;
   */
  areaMappings: AreaMapping[];
};

/**
 * Describes the message internalapi.v1.OrganizationContract.
 * Use `create(OrganizationContractSchema)` to create a new message.
 */
export const OrganizationContractSchema: GenMessage<OrganizationContract> = /*@__PURE__*/
  messageDesc(file_internalapi_v1_contract_model, 6);

/**
 * @generated from enum internalapi.v1.PhysicalContractDeliveryType
 */
export enum PhysicalContractDeliveryType {
  /**
   * @generated from enum value: PHYSICAL_CONTRACT_DELIVERY_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PHYSICAL_CONTRACT_DELIVERY_TYPE_BG = 1;
   */
  BG = 1,

  /**
   * @generated from enum value: PHYSICAL_CONTRACT_DELIVERY_TYPE_JEPX = 2;
   */
  JEPX = 2,
}

/**
 * Describes the enum internalapi.v1.PhysicalContractDeliveryType.
 */
export const PhysicalContractDeliveryTypeSchema: GenEnum<PhysicalContractDeliveryType> = /*@__PURE__*/
  enumDesc(file_internalapi_v1_contract_model, 0);

/**
 * @generated from enum internalapi.v1.EclearOption
 */
export enum EclearOption {
  /**
   * @generated from enum value: ECLEAR_OPTION_UNSPECIFIED = 0;
   */
  ECLEAR_OPTION_UNSPECIFIED = 0,

  /**
   * @generated from enum value: ECLEAR_OPTION_1_1 = 1;
   */
  ECLEAR_OPTION_1_1 = 1,

  /**
   * @generated from enum value: ECLEAR_OPTION_1_2 = 2;
   */
  ECLEAR_OPTION_1_2 = 2,

  /**
   * @generated from enum value: ECLEAR_OPTION_1_3 = 3;
   */
  ECLEAR_OPTION_1_3 = 3,

  /**
   * @generated from enum value: ECLEAR_OPTION_2_1 = 4;
   */
  ECLEAR_OPTION_2_1 = 4,

  /**
   * @generated from enum value: ECLEAR_OPTION_2_2 = 5;
   */
  ECLEAR_OPTION_2_2 = 5,
}

/**
 * Describes the enum internalapi.v1.EclearOption.
 */
export const EclearOptionSchema: GenEnum<EclearOption> = /*@__PURE__*/
  enumDesc(file_internalapi_v1_contract_model, 1);

/**
 * @generated from enum internalapi.v1.MarginCallFrequency
 */
export enum MarginCallFrequency {
  /**
   * @generated from enum value: MARGIN_CALL_FREQUENCY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MARGIN_CALL_FREQUENCY_DAILY = 1;
   */
  DAILY = 1,

  /**
   * @generated from enum value: MARGIN_CALL_FREQUENCY_WEEKLY = 2;
   */
  WEEKLY = 2,

  /**
   * @generated from enum value: MARGIN_CALL_FREQUENCY_BIWEEKLY = 3;
   */
  BIWEEKLY = 3,
}

/**
 * Describes the enum internalapi.v1.MarginCallFrequency.
 */
export const MarginCallFrequencySchema: GenEnum<MarginCallFrequency> = /*@__PURE__*/
  enumDesc(file_internalapi_v1_contract_model, 2);

/**
 * @generated from enum internalapi.v1.MarginCallWeekday
 */
export enum MarginCallWeekday {
  /**
   * @generated from enum value: MARGIN_CALL_WEEKDAY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MARGIN_CALL_WEEKDAY_MONDAY = 1;
   */
  MONDAY = 1,

  /**
   * @generated from enum value: MARGIN_CALL_WEEKDAY_TUESDAY = 2;
   */
  TUESDAY = 2,

  /**
   * @generated from enum value: MARGIN_CALL_WEEKDAY_WEDNESDAY = 3;
   */
  WEDNESDAY = 3,

  /**
   * @generated from enum value: MARGIN_CALL_WEEKDAY_THURSDAY = 4;
   */
  THURSDAY = 4,

  /**
   * @generated from enum value: MARGIN_CALL_WEEKDAY_FRIDAY = 5;
   */
  FRIDAY = 5,
}

/**
 * Describes the enum internalapi.v1.MarginCallWeekday.
 */
export const MarginCallWeekdaySchema: GenEnum<MarginCallWeekday> = /*@__PURE__*/
  enumDesc(file_internalapi_v1_contract_model, 3);

/**
 * @generated from enum internalapi.v1.Clearer
 */
export enum Clearer {
  /**
   * @generated from enum value: CLEARER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CLEARER_STONEX = 1;
   */
  STONEX = 1,

  /**
   * @generated from enum value: CLEARER_KGI = 2;
   */
  KGI = 2,
}

/**
 * Describes the enum internalapi.v1.Clearer.
 */
export const ClearerSchema: GenEnum<Clearer> = /*@__PURE__*/
  enumDesc(file_internalapi_v1_contract_model, 4);

